import React, { useCallback } from 'react';
import { ServicesContext } from '~/services';
import { enumValue } from '~/util';

export const useBulkImport = () => {
    const services = React.useContext(ServicesContext);

    const bulkImport = useCallback(
        async (files: DropzoneFileType[]) => {
            const data = new FormData();
            data.set(
                'data',
                JSON.stringify({
                    type: enumValue(['document', 'type', 'User import uploaded document']),
                })
            );
            files.forEach((file, index) => data.append(`file${index + 1}`, file));
            const result = await services.api.call({
                method: 'post',
                url: '/api/documents',
                data,
            });
            return result;
        },
        [services.api]
    );

    return bulkImport;
};
